const initialState = { InstituteFormData: {} }

export default (state = initialState, action) => {
  if (action.type === 'SAVE_FORM_INSTITUTE_DATA') {
    return { ...state, InstituteFormData: action.InstituteFormData }
  } else {
    return state
  }
}
